import { Container, WebuiIocKey } from '@ztechapps/webui.contract'
import { productContainer } from '@ztechapps/product.webui'
import { workOrderContainer } from '@ztechapps/work-order.webui'
import { adjustmentContainer } from '@ztechapps/adjustment.webui'
import { purchaseOrderContainer } from '@ztechapps/purchase-order.webui'
import { vendorContainer } from '@ztechapps/vendor.webui'
import { projectContainer } from '@ztechapps/project.webui'
import { routesDef } from './routes'
import type { RouteDef } from '@ztechapps/common.contract'
import { customerContainer } from '@ztechapps/customer.webui'
import { companyContainer } from '@ztechapps/company.webui'
import { aiWebuiContainer } from '@ztechapps/ai.webui'
import { orderContainer } from '@ztechapps/order.webui'
import { ConversationTemplateVariablesProvider } from '../components/conversation/ConversationTemplateVariablesProvider'
import { VendorInfoForm } from '../components/vendor-info-form/VendorInfoForm'

export function setupContainer() {
  const container = new Container()
  container.load(
    productContainer,
    customerContainer,
    companyContainer,
    workOrderContainer,
    adjustmentContainer,
    purchaseOrderContainer,
    vendorContainer,
    projectContainer,
    aiWebuiContainer,
    orderContainer
  )
  container.bind(WebuiIocKey.vendor.vendorInfoForm).to(VendorInfoForm)

  //load the route
  container.bind<RouteDef>(WebuiIocKey.routes.productItem).to(routesDef.ProductItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.orderItem).to(routesDef.OrderItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.purchaseOrderItem).to(routesDef.PurchaseItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.customerContactItem).to(routesDef.CustomerItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.customerCompanyItem).to(routesDef.CompanyItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.companyItem).to(routesDef.CompanyItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.vendorContactItem).to(routesDef.VendorItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.projectItem).to(routesDef.ProjectItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.projectList).to(routesDef.ProjectsPage)
  container.bind<RouteDef>(WebuiIocKey.routes.workOrderItem).to(routesDef.ProductionItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.workOrderList).to(routesDef.ProductionPage)
  container.bind<RouteDef>(WebuiIocKey.routes.taskItem).to(routesDef.TaskItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.logisticItem).to(routesDef.LogisticItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.logisticList).to(routesDef.LogisticListPage)
  container.bind<RouteDef>(WebuiIocKey.routes.adjustmentItem).to(routesDef.AdjustmentItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.adjustmentList).to(routesDef.AdjustmentPage)
  container.bind<RouteDef>(WebuiIocKey.routes.conversationItem).to(routesDef.ConversationItemPage)
  container.bind<RouteDef>(WebuiIocKey.routes.blogList).to(routesDef.BlogsPage)
  container.bind<RouteDef>(WebuiIocKey.routes.blogItem).to(routesDef.BlogItemPage)
  container.bind(WebuiIocKey.chat.conversationTemplateVariablesProvider).to(ConversationTemplateVariablesProvider)

  return container
}
